import React, { useState } from "react";
import Alert from "@mui/material/Alert";

// estilos
import { styled } from "@mui/material/styles";

//iconos
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

  const Div = styled("div")(({ theme }) => ({
    marginBottom: 15,
    marginTop: 15,
  }));
  
  const Alerta = styled(Alert)(({ theme }) => ({
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
      marginBottom: 15,
      color: "#799f4f",
    },
  }));
  
const DatosSituacion = (props) => {

  return (
    <>
      <Div>
        {props?.existe ?(
            <div>
              <Alerta
                severity="success"
                icon={
                    <CheckCircleOutlineIcon
                    sx={{ color: "#799f4f", height: 1 }}
                    />
                }
                >
                <b>SITUACIÓN:</b>
                {" " + props?.datos_situacion}
              </Alerta>
            </div>
        ):null}
      </Div>
    </>
  );
};

export default DatosSituacion;